import type {FinishedResponseInteractionService} from 'shared/services';
import type {FinishedSaveResponse, Rec} from 'src/typings';
import type {RecordCollectionsDataService} from '../record-collections.data-service';
import type {RecordCollectionItem} from '../types';

export class KpCollectionBulkInsertButtonPresenter {
    public static presenterName = 'kpCollectionBulkInsertButtonPresenter';

    /*@ngInject*/
    constructor(private recordCollectionsDataService: RecordCollectionsDataService, private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async insertMultipleToCollection(records: Rec[]): Promise<FinishedSaveResponse<RecordCollectionItem[]>> {
        try {
            const response = await this.recordCollectionsDataService.insertMultipleCollectionItems({records, recordCollection: null});
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(response);
            return response;
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
            throw e;
        }
    }
}